import { Say } from "../widgets/Say";

/** test aspiration */
export function Aspiration() {
  return (<>
    <h2>Aspiration</h2>
    <ul>
      <li><Say>pie</Say> --- <Say>[ˈpaɪ̯]</Say>, <Use>[ˈpʰaɪ̯]</Use>, <Say>[ˈp˭aɪ̯]</Say></li>
      <li><Say>spy</Say> --- <Use>[ˈspaɪ̯]</Use>, <Say>[ˈspʰaɪ̯]</Say>, <Say>[ˈsp˭aɪ̯]</Say></li>
      <li><Say>puppy</Say> --- <Say>[ˈpəpi]</Say>, <Say>[ˈpʰəpʰi]</Say>, <Use>[ˈpʰəpi]</Use></li>
      <li><Say>papoose</Say> --- <Say>[pæˈpus]</Say>, <Use>[pʰæˈpʰus]</Use></li>
      <li><Say>pry</Say> --- <Say>[ˈpɹaɪ̯]</Say>, <Use>[ˈpʰɹaɪ̯]</Use>, <Say>[ˈp˭ɹaɪ̯]</Say></li>
      <li><Say>spry</Say> --- <Use>[ˈspɹaɪ̯]</Use>, <Say>[ˈspʰɹaɪ̯]</Say>, <Say>[ˈsp˭ɹaɪ̯]</Say></li>
      <li><Say>ply</Say> --- <Say>[ˈpɫaɪ̯]</Say>, <Use>[ˈpʰɫaɪ̯]</Use>, <Say>[ˈp˭ɫaɪ̯]</Say></li>
      <li><Say>pure</Say> --- <Say>[ˈpjɤɹ]</Say>, <Use>[ˈpʰjɤɹ]</Use>, <Say>[ˈp˭jɤɹ]</Say></li>
      <li><Say>pueblo</Say> --- <Say>[ˈpwɛbɫoʊ̯]</Say>, <Use>[ˈpʰwɛbɫoʊ̯]</Use>, <Say>[ˈp˭wɛbɫoʊ̯]</Say></li>
      <li><Say>bop</Say> --- <Use>[ˈbɑp]</Use>, <Say>[ˈbɑpʰ]</Say>, <Say>[ˈbɑp˭]</Say></li>
    </ul>

    <ul>
      <li><Say>tie</Say> --- <Say>[ˈtaɪ̯]</Say>, <Use>[ˈtʰaɪ̯]</Use></li>
      <li><Say>sty</Say> --- <Use>[ˈstaɪ̯]</Use>, <Say>[ˈstʰaɪ̯]</Say></li>
      <li><Say>teton</Say> --- <Say>[ˈtiˌtɑn]</Say>, <Use>[ˈtʰiˌtʰɑn]</Use>, <Say>[ˈtʰiˌtɑn]</Say></li>
      <li><Say>titanic</Say> --- <Say>[taɪ̯ˈtænɪk]</Say>, <Use>[tʰaɪ̯ˈtʰænɪk]</Use></li>
      <li><Say>try</Say> --- <Say>[ˈtɹaɪ̯]</Say>, <Use>[ˈtʰɹaɪ̯]</Use></li>
      <li><Say>stray</Say> --- <Use>[ˈstɹeɪ̯]</Use>, <Say>[ˈstʰɹeɪ̯]</Say></li>
      <li><Say>atlas</Say> --- <Say>[ˈætɫɨs]</Say>, <Use>[ˈætʰɫɨs]</Use></li>
      <li><Say>twin</Say> --- <Say>[ˈtwɪn]</Say>, <Use>[ˈtʰwɪn]</Use></li>
      <li><Say>bot</Say> --- <Use>[ˈbɑt]</Use>, <Say>[ˈbɑtʰ]</Say></li>
    </ul>

    <ul>
      <li><Say>kai</Say> --- <Say>[ˈkaɪ̯]</Say>, <Use>[ˈkʰaɪ̯]</Use>, <Say>[ˈk˭aɪ̯]</Say></li>
      <li><Say>sky</Say> --- <Use>[ˈskaɪ̯]</Use>, <Say>[ˈskʰaɪ̯]</Say>, <Say>[ˈsk˭aɪ̯]</Say></li>
      <li><Say>khaki</Say> --- <Say>[ˈkæki]</Say>, <Say>[ˈkʰækʰi]</Say>, <Use>[ˈkʰæki]</Use>, <Say>[ˈkʰæk˭i]</Say></li>
      <li><Say>cacao</Say> --- <Say>[kəˈkaʊ̯]</Say>, <Use>[kʰəˈkʰaʊ̯]</Use></li>
      <li><Say>craze</Say> --- <Say>[ˈkɹeɪ̯z]</Say>, <Use>[ˈkʰɹeɪ̯z]</Use>, <Say>[ˈk˭ɹeɪ̯z]</Say></li>
      <li><Say>scry</Say> --- <Use>[ˈskɹaɪ̯]</Use>, <Say>[ˈskʰɹaɪ̯]</Say>, <Say>[ˈsk˭ɹaɪ̯]</Say></li>
      <li><Say>clay</Say> --- <Say>[ˈkɫeɪ̯]</Say>, <Use>[ˈkʰɫeɪ̯]</Use>, <Say>[ˈk˭ɫeɪ̯]</Say></li>
      <li><Say>cure</Say> --- <Say>[ˈkjɤɹ]</Say>, <Use>[ˈkʰjɤɹ]</Use>, <Say>[ˈk˭jɤɹ]</Say></li>
      <li><Say>quack</Say> --- <Say>[ˈkwæk]</Say>, <Use>[ˈkʰwæk]</Use>, <Say>[ˈk˭wæk]</Say></li>
      <li><Say>walk</Say> --- <Use>[ˈwɑk]</Use>, <Say>[ˈwɑkʰ]</Say>, <Say>[ˈwɑk˭]</Say></li>
    </ul>

    <ul>
      <li><Say>[ˈtsaɪ̯]</Say>, <Say>[ˈt͡saɪ̯]</Say>, <Say>[ˈt͡sʰaɪ̯]</Say>, <Say>[ˈt͡shaɪ̯]</Say></li>
      <li><Use>[tsɘˈnɑmi]</Use>, <Say>[t͡sʰɘˈnɑmi]</Say>, <Say>[t͡sɘˈnɑmi]</Say></li>
      <li><Use>[ˈpitsɐ]</Use>, <Say>[ˈpit͡sʰɐ]</Say>, <Say>[ˈpit͡sɐ]</Say></li>
      <li><Use>[ˈbɯu̯ts]</Use>, <Say>[ˈbɯu̯t͡sʰ]</Say>, <Say>[ˈbɯu̯t͡s]</Say></li>
    </ul>

    <ul>
      <li>tap: <Say language='Spanish' accent='Mexico'>tapa</Say></li>
      <li>tengo: <Say language='Spanish' accent='Mexico'>tengo</Say></li>
      <li>casa que pasa: <Say language='Spanish' accent='Mexico'>casa que pasa</Say></li>
    </ul>

    faked:

    <ul>
      <li><Say>[ˈbaɪ̯]</Say>, <Say>[ˈbʰaɪ̯]</Say>, <Say>[ˈbhaɪ̯]</Say></li>
      <li><Say>[ˈbɹaɪ̯]</Say>, <Say>[ˈbʰɹaɪ̯]</Say>, <Say>[ˈbhɹaɪ̯]</Say></li>
      <li><Say>[ˈsbɹaɪ̯]</Say>, <Say>[ˈsbʰɹaɪ̯]</Say>, <Say>[ˈsbhɹaɪ̯]</Say></li>
      <li><Say>[ˈbɫaɪ̯]</Say>, <Say>[ˈbʰɫaɪ̯]</Say>, <Say>[ˈbhɫaɪ̯]</Say></li>
      <li><Say>[ˈbjɤɹ]</Say>, <Say>[ˈbʰjɤɹ]</Say>, <Say>[ˈbhjɤɹ]</Say></li>
      <li><Say>[ˈbwɛbɫoʊ̯]</Say>, <Say>[ˈbʰwɛbɫoʊ̯]</Say>, <Say>[ˈbhwɛbɫoʊ̯]</Say></li>
      <li><Say>[ˈbɑb]</Say>, <Say>[ˈbɑbʰ]</Say>, <Say>[ˈbɑbh]</Say></li>
    </ul>

    <ul>
      <li><Say>[ˈdeɪ̯]</Say>, <Say>[ˈdʰeɪ̯]</Say>, <Say>[ˈdheɪ̯]</Say></li>
      <li><Say>[ˈsdaɪ̯]</Say>, <Say>[ˈsdʰaɪ̯]</Say> <Say>[ˈsdhaɪ̯]</Say></li>
      <li><Say>[ˈdɹaɪ̯]</Say>, <Say>[ˈdʰɹaɪ̯]</Say> <Say>[ˈdhɹaɪ̯]</Say></li>
      <li><Say>[ˈsdɹeɪ̯]</Say>, <Say>[ˈsdʰɹeɪ̯]</Say><Say>[ˈsdhɹeɪ̯]</Say></li>
      <li><Say>[ˈdwɪn]</Say>, <Say>[ˈdʰwɪn]</Say> <Say>[ˈdhwɪn]</Say></li>
      <li><Say>[ˈbɑd]</Say>, <Say>[ˈbɑdʰ]</Say>, <Say>[ˈbɑdh]</Say></li>
    </ul>

    <ul>
      <li><Say>[ˈgaɪ̯]</Say>, <Say>[ˈgʰaɪ̯]</Say>, <Say>[ˈghaɪ̯]</Say></li>
      <li><Say>[ˈsgaɪ̯]</Say>, <Say>[ˈsgʰaɪ̯]</Say>, <Say>[ˈsghaɪ̯]</Say></li>
      <li><Say>[ˈgɹeɪ̯z]</Say>, <Say>[ˈgʰɹeɪ̯z]</Say>, <Say>[ˈghɹeɪ̯z]</Say></li>
      <li><Say>[ˈgɫeɪ̯]</Say>, <Say>[ˈgʰɫeɪ̯]</Say>, <Say>[ˈghɫeɪ̯]</Say></li>
      <li><Say>[ˈgjɤɹ]</Say>, <Say>[ˈgʰjɤɹ]</Say>, <Say>[ˈghjɤɹ]</Say></li>
      <li><Say>[ˈgwæk]</Say>, <Say>[ˈgʰwæk]</Say>, <Say>[ˈghwæk]</Say></li>
      <li><Say>[ˈwɑg]</Say>, <Say>[ˈwɑgʰ]</Say>, <Say>[ˈwɑgh]</Say></li>
    </ul>

    <ul>
      <li><Say>[ˈʈaɪ̯]</Say>, <Say>[ˈʈʰaɪ̯]</Say>, <Say>[ˈʈhaɪ̯]</Say> - <Say>[ˈɖaɪ̯]</Say>, <Say>[ˈɖʰaɪ̯]</Say>, <Say>[ˈɖhaɪ̯]</Say></li>
      <li><Say>[ˈt̪aɪ̯]</Say>, <Say>[ˈt̪ʰaɪ̯]</Say>, <Say>[ˈt̪haɪ̯]</Say></li>
      <li><Say>[ˈcaɪ̯]</Say>, <Say>[ˈcʰaɪ̯]</Say>, <Say>[ˈchaɪ̯]</Say></li>
      <li><Say>[ˈqaɪ̯]</Say>, <Say>[ˈqʰaɪ̯]</Say>, <Say>[ˈqhaɪ̯]</Say></li>
      <li><Say>[ˈsaɪ̯]</Say>, <Say>[ˈsʰaɪ̯]</Say>, <Say>[ˈshaɪ̯]</Say> - <Say>[ˈzaɪ̯]</Say>, <Say>[ˈzʰaɪ̯]</Say>, <Say>[ˈzhaɪ̯]</Say></li>
      <li><Say>[ˈʃaɪ̯]</Say>, <Say>[ˈʃʰaɪ̯]</Say>, <Say>[ˈʃhaɪ̯]</Say> - <Say>[ˈtʃaɪ̯]</Say>, <Say>[ˈtʃʰaɪ̯]</Say>, <Say>[ˈtʃhaɪ̯]</Say></li>
      <li><Say>[ˈʒaɪ̯]</Say>, <Say>[ˈʒʰaɪ̯]</Say>, <Say>[ˈʒhaɪ̯]</Say> - <Say>[ˈdʒaɪ̯]</Say>, <Say>[ˈdʒʰaɪ̯]</Say>, <Say>[ˈdʒhaɪ̯]</Say></li>
      <li><Say>[ˈçaɪ̯]</Say>, <Say>[ˈçʰaɪ̯]</Say>, <Say>[ˈçhaɪ̯]</Say> - <Say>[ˈʝaɪ̯]</Say>, <Say>[ˈʝʰaɪ̯]</Say>, <Say>[ˈʝhaɪ̯]</Say></li>
      <li><Say>[ˈɕaɪ̯]</Say>, <Say>[ˈɕʰaɪ̯]</Say>, <Say>[ˈɕhaɪ̯]</Say> - <Say>[ˈʑaɪ̯]</Say>, <Say>[ˈʑʰaɪ̯]</Say>, <Say>[ˈʑhaɪ̯]</Say></li>
      <li><Say>[ˈfaɪ̯]</Say>, <Say>[ˈfʰaɪ̯]</Say>, <Say>[ˈfhaɪ̯]</Say></li>
      <li><Say>[ˈxaɪ̯]</Say>, <Say>[ˈxʰaɪ̯]</Say>, <Say>[ˈxhaɪ̯]</Say> - <Say>[ˈɣaɪ̯]</Say>, <Say>[ˈɣʰaɪ̯]</Say>, <Say>[ˈɣhaɪ̯]</Say></li>
      <li><Say>[ˈθaɪ̯]</Say>, <Say>[ˈθʰaɪ̯]</Say>, <Say>[ˈθhaɪ̯]</Say> - <Say>[ˈðaɪ̯]</Say>, <Say>[ˈðʰaɪ̯]</Say>, <Say>[ˈðhaɪ̯]</Say></li>
    </ul>

    <ul>
      <li><Say>[kǀa]</Say>, <Say>[kǀʰa]</Say>, <Say>[kǀha]</Say></li>
      <li><Say>[gǀa]</Say>, <Say>[gǀʰa]</Say>, <Say>[gǀha]</Say></li>
      <li><Say>[aŋǀa]</Say>, <Say>[aŋǀʰa]</Say>, <Say>[aŋǀha]</Say></li>
    </ul>

  </>)
}

function Use(props: { children: string }) {
  return <Say textColor="rgb(100,100,200)">{props.children}</Say>;
}
